export default __webpack_public_path__ + "total-staff-white-icon.svg";